import axios from 'axios';
import { environment } from '../../../config/env';
import { IPinPayload } from './_models';
const API_URL = environment.API_URL,
  UPDATE_PIN_URL = `${API_URL}/card/update-pin`;

export const updatePIN = (PINPayload: IPinPayload) => {
  return axios.post(`${UPDATE_PIN_URL}`, PINPayload).then(response => response.data);
};
